import { render, staticRenderFns } from "./StarsBackground.vue?vue&type=template&id=b6ffb1e4&scoped=true&"
import script from "./StarsBackground.vue?vue&type=script&lang=ts&"
export * from "./StarsBackground.vue?vue&type=script&lang=ts&"
import style0 from "./StarsBackground.vue?vue&type=style&index=0&id=b6ffb1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ffb1e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b6ffb1e4', component.options)
    } else {
      api.reload('b6ffb1e4', component.options)
    }
    module.hot.accept("./StarsBackground.vue?vue&type=template&id=b6ffb1e4&scoped=true&", function () {
      api.rerender('b6ffb1e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/components/StarsBackground.vue"
export default component.exports